import script from "./typificationHistoryModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./typificationHistoryModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__